import { AlertIcon } from '@approvalmax/ui';
import { Alert, Fade, Grid, Table } from '@approvalmax/ui/src/components';
import { useController, useFormContext } from 'react-hook-form';
import { z } from 'zod';

import { schema } from '../../../resources/schema';
import { columns } from './SettingsTable.constants';
import { usePersons } from './SettingsTable.hooks';

export const SettingsTable = () => {
    const { control, formState } = useFormContext<z.infer<typeof schema>>();
    const { fieldState } = useController({ name: 'people.persons', control });
    const persons = usePersons();

    return (
        <Grid gap={8}>
            <Table
                hoverable={false}
                qa='persons-settings'
                progress={formState.disabled}
                progressRowCount={3}
                columns={columns}
                data={persons}
            />

            <Fade in={Boolean(fieldState.error?.root?.message)}>
                <Alert
                    data-qa='validation-error'
                    alignItems='center'
                    color='red20'
                    size='small'
                    startIcon={<AlertIcon />}
                >
                    {fieldState.error?.root?.message}
                </Alert>
            </Fade>
        </Grid>
    );
};

SettingsTable.displayName = 'SettingsTable';
